<script lang="ts">
import { ref } from 'vue';
import type { Logo } from '../../types/storeConfig';
import { useStoreTranslations } from '../../store/translations/translations';

type Props = {
  imageConfig?: Logo;
  baseUrl?: string;
  variant: 'original' | 'inverted';
};
</script>

<script setup lang="ts">
defineProps<Props>();
const hasLoadError = ref<boolean>(false);
const storeTranslations = useStoreTranslations();

const loadError = () => {
  return (hasLoadError.value = true);
};
</script>
<template>
  <a
    :class="$style.homeLink"
    :href="imageConfig?.startpageUrl ? imageConfig.startpageUrl : baseUrl || '/'"
  >
    <template v-if="variant === 'original'">
      <img
        v-if="!hasLoadError"
        alt="WIKA logo"
        :src="imageConfig?.mediaOriginal?.mediaUrl"
        @error="loadError()"
      />
      <span v-else :class="$style.logoWithoutMedia"></span>
    </template>
    <template v-else>
      <img
        v-if="!hasLoadError"
        alt="WIKA logo"
        :src="imageConfig?.mediaInverted?.mediaUrl"
        @error="loadError()"
      />
      <span v-else :class="[$style.logoWithoutMedia, $style.inverted]"></span>
    </template>
    <span class="accessible-link-text">
      {{ storeTranslations.translations?.['logo.accessibleLinkText'] }}
    </span>
  </a>
</template>
<style module lang="scss">
@forward './Logo.scss';
</style>
